//react component

import React, {useState, useEffect} from 'react';
import axios from './axios';
import "./Row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";

const base_url = "https://image.tmdb.org/t/p/original/";

function Row({title, fetchUrl, isLargeRow}){
    const [movies, setMovies] = useState([]);
    const [trailerUrl, setTrailerUrl] = useState("");
    /**way to declare variables
     * Give empty usestae react, then pull it from react {}
     */

    //a snippet of code which runs based on a specific condition/variable

    useEffect(() => {
        //run code, when the row loads, e.g Trending Now, and make a request from tmdb
        //Anytime the trending now row loads, useEffect runs
        
        async function fetchData(){
            const request = await axios.get(fetchUrl);
            //console.log() //be able to see the data structure that gets back
            setMovies(request.data.results);  //array
            return request;
        }
        fetchData();
    }, [fetchUrl]); //url pulled from outside, have to pass it inside the []

    //if we leave[] empty, it wil only run when the page loads, and dont run again
        //but if we pass a variable e.g [movie], it will run everytime the movies variable changes the useeffect will run

    //console.table(movies);

    const opts = {
        height: "390",
        width: "100%",
        playerVars: {
            //https://developers.google.com/youtube/player_parameters,
            autoplay: 1,
        },
    };

    const handleClick = (movie) => {
        if (trailerUrl) {
            setTrailerUrl("");
        } else {
            movieTrailer(movie?.name || "")
                .then((url) => {
                    const urlParams = new URLSearchParams(new URL(url).search);
                    setTrailerUrl(urlParams.get("v"));
                })
                .catch((error) => console.log(error));
        }
    };

    return (

        <div className="row">

            <h2>{title}</h2>

            <div className="row_posters">
                {movies.map((movie) =>(
                    <img key={movie.id}
                        onClick={() => handleClick(movie)}
                        className={`row_poster ${isLargeRow && "row_posterLarge"}`}
                        src={`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`}
                    alt={movie.name} />
                ))}
            </div>

            {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}

        </div>
    );

}

export default Row